const getLastMessage = async ({ rootGetters, dispatch }, payload) => {
    try {
        const customer = rootGetters["customer/CUSTOMER"];
        const selected_customer = rootGetters["customer/SELECTED_CUSTOMER"];
        const data = { ...payload, customer_id: customer.customer_id };

        if (customer.customer_id === 0) {
            data.customer_id = selected_customer.customer_id;
        }

        const response = await window.axios.get(`/proxy/ai/sessions/${payload.sessionId}/messages/last?customer_id=${data.customer_id}`, data);
        if (response && response.data.success) {
            return response.data.message;
        } else {
            throw response.data;
        }
    } catch (error) {
        dispatch("notifications/setError", error.message, { root: true });
    }
};

export default getLastMessage;